
const SAUCELABS_DOCUMENTATION_URLS = {
    CAPABILITIES_DOCUMENTAION:'https://docs.saucelabs.com/basics/test-config-annotation/test-config/#capabilities-for-selenium-and-appium-tests'
}

export {SAUCELABS_DOCUMENTATION_URLS}